var list = blockDates.split(",");
var mindate = daysAdvance;
var dateTemp = "";
var dateNow = "";

function DisableDates(date) {
    var string = jQuery.datepicker.formatDate('mm/dd/yy', date);
    return [list.indexOf(string) == -1];
}

$(function(){
   var el = $(".div_temp").html();
   if(el !== undefined){
      $(".div_shipping_date").append(el);
      $(".div_temp").html("");
   }

   setTimeout(function(){   
   	$("#date_input").datepicker({
       dateFormat: 'mm/dd/yy',
       minDate: '+'+mindate+'D',
       maxDate: '+1Y',
       beforeShowDay: DisableDates
    });
    
    dateNow = $("#date_input").datepicker("getDate");
    dateNow = jQuery.datepicker.formatDate('mm/dd/yy', dateNow);
     
    if(ShippingDate !== undefined){     		
		$("#date_input").datepicker( "setDate", ShippingDate);
      	dateTemp = ShippingDate;
      	$("#shipping_date").val(ShippingDate);
    }else{
      	var currentDate = $("#date_input").datepicker("getDate");
        currentDate.setDate(currentDate.getDate() + parseInt(mindate));
        currentDate = jQuery.datepicker.formatDate('mm/dd/yy', currentDate);
        dateTemp = currentDate;
        $("#shipping_date").val(currentDate);
    }

   }, 1500);
  
  	$("#date_input" ).on("change",function(){
  		var currentDate = $("#date_input").datepicker("getDate");
        currentDate = jQuery.datepicker.formatDate('mm/dd/yy', currentDate);
      	dateTemp = currentDate;
        $("#shipping_date").val(currentDate);
  	});
  
    $("#btn_now").click(function(e){
        $("#date_input").hide();
      	$(".btn_option").removeClass("active");
      	$("#btn_now").addClass("active");
      	$("#date_input").datepicker( "setDate", dateNow);
      	$("#shipping_date").val(dateNow);      	
    });
  
    $("#btn_later").click(function(e){
        $("#date_input").show();
      	$(".btn_option").removeClass("active");
      	$("#btn_later").addClass("active");
      	$("#date_input").datepicker( "setDate", dateTemp);
      	$("#shipping_date").val(dateTemp);
    });
    $('.ui-state-highlight').removeClass('ui-state-highlight');
    $(document).ready(function(){
          $('#btn_now').trigger("click");
          $('.item-banner').addClass('show-item');
    })
});

const GIFT_THRESHOLD = 3 // According to marketing policy
$(function(){
if($("body").hasClass("template-cart")) {
  $.ajax({
    url : '/cart.js',
    type : 'GET',
    dataType: 'json',
    success: function(cart){
      var total = 0;
      var warranty_item = "";
      var activity_item = "";
      var activity_amount = 0
      
      for(var i in cart.items) {
        item = cart.items[i];
        if(item.product_type == 'Warranty') {
          warranty_item = item;
        } else if(item.product_type == 'Gift') {
          activity_item = item;
        } else {
          total += Math.max(item.line_price, 0);
        }
      }
      total = 0.1 * total;
      total = Math.round(total)
      $('.activity-flag').each(function() {
        const num = $(this).attr('cart-quantity')
        activity_amount += Number(num)
      })

      if(warranty_item != "") {
        if(total < warranty_item.original_line_price) {
          $(".cart-loading").css("display","flex");
          uu = {};
          if(activity_item !== "" && activity_amount < GIFT_THRESHOLD) {
            uu[activity_item.key] = 0;
          }
          uu[warranty_item.key] = 0;
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: uu },
            dataType: 'json',
            success:function(line_item){
              args = {};
              args["input_number"] = total / 100;
              args["product_title"] = "90 day warranty。";
              args["product_image"] = "https://lotsofplants.com/cdn/shop/files/LOP_Favicon_500x.png?v=1787136097";
              $.ajax({
                type: 'POST',
                url: '/apps/warranty',
                data: args,
                dataType: 'json',
                success:function(line_item){
                  _args = []
                  if(activity_item === '' && activity_amount >= GIFT_THRESHOLD) {
                    _args = [{ quantity: 1, id: '40570815217744' }] // gift product $0.01
                  }
                  try{
                    variant_id = JSON.parse(line_item);
                  }catch(err) {
                    console.log('err111', err)
                    variant_id = line_item[0];
                  }
                  args =  [{ quantity: 1, id: variant_id }, ..._args]
                  $.ajax({
                      type: 'POST',
                      url: '/cart/add.js',
                      data: {
                        items: args
                      },
                      dataType: 'json',
                      error: function (error) {
                          e = JSON.parse(error.responseText)
                          desc = e.description
                          alert(desc)
                      },
                      success: function (cart) {
                          location = "/cart";
                      }
                  })
                }
              });
            }
          });
        } else {
          $("#warranty").attr("checked",true);
        }
      }

      if(activity_item != "") {
        if(activity_amount < GIFT_THRESHOLD) {
          if($('.cart-loading').css('display') == 'flex') {
            return
          }
          $(".cart-loading").css("display","flex");
          uu = {};
          uu[activity_item.key] = 0;
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { updates: uu },
            dataType: 'json',
            success:function(line_item){
              location = "/cart";
            }
          })
        }
      } else {
        if(activity_amount >= GIFT_THRESHOLD) {
          if($('.cart-loading').css('display') == 'flex') {
            return
          }
          $(".cart-loading").css("display","flex");
          args = { quantity: 1, id: '40570815217744' }
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: args,
              dataType: 'json',
              error: function (error) {
                  e = JSON.parse(error.responseText)
                  desc = e.description
                  alert(desc)
              },
              success: function (cart) {
                  location = "/cart";
              }
          })
        }
      }
    }
  })
}

  $("#warranty").on("click",function(){
    $(".cart-loading").css("display","flex");
      if($(this).is(":checked")) {
        $.ajax({
          url : '/cart.js',
          type : 'GET',
          dataType: 'json',
          success: function(cart){
            var total = 0;
            for(var i in cart.items) {
              item = cart.items[i];
              if(item.product_type != "Warranty" && item.product_type != "Gift") {
                total += Math.max(item.line_price, 0);
              }
            }
          total = 0.1 * total;
          total = Math.round(total)
          args = {};
          args["input_number"] = total / 100;
          args["product_title"] = "90 day warranty。";
          args["product_image"] = "https://lotsofplants.com/cdn/shop/files/LOP_Favicon_500x.png?v=1787136097";
          $.ajax({
            type: 'POST',
            url: '/apps/warranty',
            data: args,
            dataType: 'json',
            success:function(line_item){
              try{
                variant_id = JSON.parse(line_item);
              }catch(err) {
                console.log('err222', err)
                variant_id = line_item[0];
              }
              args = { quantity: 1, id: variant_id }
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: args,
                        dataType: 'json',
                        error: function (error) {
                            e = JSON.parse(error.responseText)
                            desc = e.description
                            alert(desc)
                        },
                        success: function (cart) {
                            location = "/cart";
                        }
                    })
            }
          });
          }
        });
      } else {
        $.ajax({
          url : '/cart.js',
          type : 'GET',
          dataType: 'json',
          success: function(cart){
            var warranty_item = "";
      for(var i in cart.items)
      {
        item = cart.items[i];
        if(item.product_type == "Warranty" )
        {
          warranty_item = item;
          break;
        }
      }
      if(warranty_item != "")
      {
        uu = {};
					uu[warranty_item.key] = 0;
							$.ajax({
								type: 'POST',
								url: '/cart/update.js',
								data: { updates: uu },
								dataType: 'json',
								success:function(line_item){
                  location = "/cart";
                }
              });
      }
          }
        });
      }
  });
});
$(function(){
  $('body').on('click', '.save_for_later', function(e) {
      var product = {};
      product.varian_id = $(this).closest('.cart__table-block-wrap').attr('data-varial-id');
      product.title = $(this).closest('.cart__table-block-wrap').find('.cart__item-name').text();
      product.variantitle = $(this).closest('.cart__table-block-wrap').find('.cart__item-sub-name').text();
      product.price = $(this).closest('.cart__table-block-wrap').find('.cart__item-price').text();
      product.srcimg = $(this).closest('.cart__table-block-wrap').find('.cart__item-img').attr('data-src');
      product.url =$(this).closest('.cart__table-block-wrap').find('.cart__item-link-wrap').attr('href');

      if (typeof(Storage) !== 'undefined') {
        
        if (localStorage.getItem("product_id_cart") != null) {
          var save_list_product = [];

          var data = JSON.parse(localStorage.getItem("product_id_cart"));
          $.each(data, function(i, item) {
              save_list_product[i] = data[i];
          });
         
          save_list_product.push(product);
          localStorage.setItem('product_id_cart',  JSON.stringify(save_list_product));
        }
        else {
          var save_list_product_constuctor= [];
          save_list_product_constuctor.push(product);
          localStorage.setItem('product_id_cart', JSON.stringify(save_list_product_constuctor));
        }
      } 
    
  });   

  if($('body').hasClass('template-cart')) {
    if (typeof(Storage) !== 'undefined') {
      if (localStorage.getItem("product_id_cart") != null) {

        var list_items_after = '';
        list_items_after = localStorage.getItem("product_id_cart");

        var k = {};
        k = JSON.parse(list_items_after);

        // reload data page
       
        var list_key = $('input[name="variant_id_list"]').val();
        list_key = list_key.split(',');
       
        var save_list_product = [];
       
        $.each(k, function(i, item) {
          save_list_product[i] = k[i];
        });

        $.each(k, function(i) {
          $.each(list_key, function(j) {
            if (k[i].varian_id === list_key[j] && list_key[j] != '') {
              save_list_product = $.grep(save_list_product, function(value) {
                return value != k[i];
              });
            }
          });
        });
       
        localStorage.setItem('product_id_cart',  JSON.stringify(save_list_product));

        var product_list_event_load_cart = {};
        product_list_event_load_cart= JSON.parse(localStorage.getItem("product_id_cart"));

        // render html
        var html = '';
        var index_product = 0;
        $.each(product_list_event_load_cart, function(i, item) {
          
            html += '<div class="swiper-slide">';
            html += '<a class="product-grid-item__wrap" href="'+ product_list_event_load_cart[i].url +'">';
            html += '<div class ="product-grid-item__img">';
            html += '<img class="product-grid-item__img-circle" src="' + product_list_event_load_cart[i].srcimg + '"'+ 'alt=" " >';
            html += '</div>'
            html += '<div class="product-title">' + product_list_event_load_cart[i].title + '</div>';
            html += '<div class="cart__item-sub-name">' + product_list_event_load_cart[i].variantitle + '</div>';
            html += '<div class="product-price">' + product_list_event_load_cart[i].price + '</div>';
            html += '</a>';
            html += '</div>';
            index_product ++;
        });
       
        if (html != '') {
          $('.cart_section_save_container').removeClass('empty');
        } else {
          $('.cart_section_save_container').addClass('empty');
        }
        
        $('.mySwiper .swiper-wrapper').html(html);
        var switch_loop = false;
        switch(index_product) {
          case 1:
            switch_loop = false;
            
            $('.cart_section_save_container').addClass('one-item');
          break;
          case 2:
            switch_loop = false;
           
            $('.cart_section_save_container').addClass('two-items');
          break;
          case 3:
            switch_loop = false;
            
            $('.cart_section_save_container').addClass('three-items');
          break;
          case 4:
            switch_loop = false;
            $('.cart_section_save_container').addClass('four-items');
            break;
          default:
            switch_loop = true;
          break;
         
        }    

        var swiper = new Swiper(".mySwiper", {
          slidesPerView: 4,
          navigation: true,
          loop: switch_loop,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          breakpoints: {

            320: {
              slidesPerView: 1.5,
              spaceBetween: 40
            },
            400 :{
              slidesPerView: 2,
              spaceBetween: 40
            },
            500: {
              slidesPerView: 3,
              spaceBetween: 40
            },
            800: {
              slidesPerView: 4
            }
          }
        });
      }
      else {
        $('.cart_section_save_container').addClass('empty');
      }
    }
  }
});